import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import HorizontalScroller from './../../alpineComponents/horizontalScroller';
import TextAndImage from './../../alpineComponents/textAndImage';
import ContactInfo from './../../components/contactInfo';
import { Link } from "react-router-dom";
import  './../../utils/analytics';

export default class extends Component {
  render() {
    return (
		<div className="light-grey-background">
      <div className="medium-padding">
        <div className="small-padding centered-text">
          <h4>{'Classical Pilates Mat - Intermediate Part 1'}</h4>
        </div>
        <div className="max-width-container white-background">
          <div class='embed-container'>
            <iframe src="https://player.vimeo.com/video/519690566?h=64c073a3d2" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>

    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/videos/index.js